import { createFileRoute } from '@tanstack/react-router';
import DraftSetup from '../-components/draft/DraftSetup';
import UserMeshingView from '../-components/phase-views/UserMeshingView';
import ReviewView from '../-components/phase-views/ReviewView';
import PreprocessingLoader from '../-components/PreprocessingLoader';
import { useStudyContext } from '../-components/study-context';

function MeshRoute() {
  const ctx = useStudyContext();
  const { study, designPoints, geometries } = ctx;

  if (study.status === 'draft') {
    return (
      <div className="h-full overflow-hidden">
        <DraftSetup study={study} geometries={geometries} section="mesh" />
      </div>
    );
  }

  if (study.status === 'preprocessing') {
    return <PreprocessingLoader />;
  }

  if (study.status === 'awaiting_user_meshing') {
    return (
      <div className="h-full overflow-y-auto bg-muted/30 p-6">
        <UserMeshingView
          study={study}
          designPoints={designPoints}
          geometries={geometries}
        />
      </div>
    );
  }

  if (study.status === 'awaiting_bc_review') {
    return (
      <div className="h-full overflow-y-auto bg-muted/30 p-6">
        <ReviewView
          study={study}
          designPoints={designPoints}
          geometries={geometries}
          selectedDpId={ctx.selectedDpId}
          detailTab={ctx.detailTab}
          onSelectDp={ctx.onSelectDp}
        />
      </div>
    );
  }

  // Past meshing: the meshes read-only rather than a "moved past this step"
  // placeholder — the same rows the meshing phase shows, each opening its
  // mesh in a read-only MeshGen (`isStudyMeshingReadOnly`).
  return (
    <div className="h-full overflow-y-auto bg-muted/30 p-6">
      <UserMeshingView
        study={study}
        designPoints={designPoints}
        geometries={geometries}
      />
    </div>
  );
}

export const Route = createFileRoute('/_app/simops/$studyId/mesh')({
  component: MeshRoute,
});
